





































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import HistoryPeserta from "@/services/bridgingVclaim/HistoryPeserta";

import moment from "moment";

@Component({
  components: {}
})
export default class ModalICareBpjs extends Vue {
  @Prop({ default: 1500 }) width: number;
  @Prop({ default: null }) userId: number;
  @Prop() register: number;
  @Prop() date: string;

  showICareDialog = false;
  icareUrl = "";
  isShowICareDialogCloseBtn = false;
  icareLoading = false;

  @Watch("showICareDialog")
  changeShowICareDialog(val) {
    if (!val) {
      this.icareUrl = "";
    }
  }

  open() {
    return this.getRiwayatICare();
  }

  async getRiwayatICare() {
    const registerId = this.register,
      dokterId = this.userId;

    if (this.date < moment().format("YYYY-MM-DD")) {
      return false;
    }

    if (!this.icareLoading) {
      this.icareLoading = true;

      await HistoryPeserta.getICareByReg(registerId, dokterId.toString())
        .then(resp => {
          if (resp.status === 1) {
            this.showPopupICareDialog(resp.data);
          }
        })
        .finally(() => {
          this.icareLoading = false;
        });
    }
  }

  showPopupICareDialog(url) {
    this.icareUrl = url;
    this.showICareDialog = true;

    setTimeout(() => {
      this.isShowICareDialogCloseBtn = true;
    }, 5000);
  }
}
